import React from 'react';
import {
  AutocompleteHighlight,
  AutocompleteItem,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';

import './site-search-input.css';

const searchBarSelector = '.white-instant-search-search-box-global';

function waitForSearchBar(callback) {
  const interval = 200;

  function check(tryCount = 0) {
    const searchBars = document.querySelectorAll(searchBarSelector);
    if (searchBars.length > 0) {
      searchBars.forEach((searchBar) => callback(searchBar));
    } else if (tryCount < 300) { // try for 1 minute
      setTimeout(() => check(tryCount + 1), interval);
    }
  }

  check();
}

waitForSearchBar((searchBar) => {
  const whiteInstantSearchSearchBar = new WhiteInstantSearchBuilder();
  const settings = searchBar.dataset;

  whiteInstantSearchSearchBar
    .addAutocompleteSearchingComponent(
      [
        {
          settings: {
            placeholder: settings.placeholder ?? '',
            useRecentSearches: false,
            sources: [
              {
                getQueryParams: (query, defaultFilters) => ({
                  query,
                  filters: defaultFilters ? `AND (${defaultFilters})` : '',
                  hitsPerPage: 10,
                }),
                transformResponse: ({ hits }) => (
                  hits[0].map((hit) => ({
                    ...hit,
                    url: `/search?q=${hit.title}`,
                  }))
                ),
                templates: {
                  header: () => null,
                  item: (
                    {
                      item,
                      source,
                      components,
                      state,
                    },
                  ) => (
                    <AutocompleteItem
                      hit={item}
                      url={source.getItemUrl({ item, state })}
                      components={{ ...components, Highlight: AutocompleteHighlight }}
                      titleAttribute="title"
                      onFillQuery={() => source.onFillQuery({ item, state })}
                    />
                  ),
                  footer: () => null,
                },
              },
            ],
            onSubmit: (query) => {
              window.location.href = `${settings.searchUrl}?q=${query}`;
            },
          },
        },
      ],
      `#${searchBar.id}`,
    )
    .withIdentity(`${searchBar.id}-root`)
    .withSearchkit(
      settings.indexName ?? '',
      settings.publicUrl ?? '',
      settings.jwt ?? '',
      settings.refreshUrl ?? '',
    )
    .withoutRouting()
    .build()
    .show();
});
